module.exports = __webpack_public_path__ + "icons/original/large/large-c6.b70b863014dd77f1444a4f5dcfaf937d.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-c6.png
// module id = oJmq
// module chunks = app